import { SequenceEventsGetRequestParams } from "@lib/core";

export interface SequenceEventDefaultParams extends SequenceEventsGetRequestParams { }
export class SequenceEventDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}